// extracted by mini-css-extract-plugin
export default {"row":"SummaryRow_row__rxQPQ"};